<template>
  <div class="text_title">{{ titleText }}</div>
</template>

<script setup>
  import { toRefs } from 'vue-demi';

  const props = defineProps({ titleText: { type: String, default: '' } });
  const { titleText } = toRefs(props);
</script>

<style lang="less" scoped>
  .text_title {
    padding: 22px 0;
    font-size: 18px;
    color: #000;
    font-weight: 600;
    text-align: center;
  }
</style>